module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiCnIt.dd4016e.ttf";